import { Button, SimpleGrid } from "@mantine/core"
import { Entity } from "@/lib/schemas"
import _ from "lodash"
import { FC, useState } from "react"
import { GridItemProps } from "./GridItem"

export interface StaticGridProps<T> {
  routePath?: string
  entityLabel?: string
  GridComponent?: FC<GridItemProps<T>>
  gridBefore?: React.ReactNode
  data?: T[]
  loading?: boolean
  truncateGridCount?: number
  animated?: boolean
  isFiltering?: boolean
}

function StaticGrid<T extends Entity>(props: StaticGridProps<T>) {
  const [truncated, setTruncated] = useState(!!props.truncateGridCount)
  const GridComp = props.GridComponent!

  const dataTruncated = truncated ? props.data?.slice(0, props.truncateGridCount) : props.data

  return (
    <>
      <SimpleGrid className="gap-6" cols={{ base: 1, xs: 2, sm: 3, lg: 4 }}>
        {!props.isFiltering && props.gridBefore}
        {props.loading &&
          _.times(5, (i) => (
            <GridComp key={i} item={{ id: i } as any} routePath={props.routePath} loading className="pointer-events-none aaa" />
          ))}
        {dataTruncated?.map((item, i) => (
          <GridComp key={item.id} item={item} routePath={props.routePath} animationDelay={i * 25} animated={props.animated} />
        ))}
      </SimpleGrid>
      {truncated && (props.data?.length || 0) > (props.truncateGridCount || -1) && (
        <div className="mt-8 text-center">
          <Button
            variant="transparent"
            leftSection={<IconMaterialSymbolsFitbitArrowDownward className="size-6" />}
            onClick={() => setTruncated(false)}
            className="text-md"
          >
            All {props.entityLabel?.toLocaleLowerCase()}s
          </Button>
        </div>
      )}
    </>
  )
}

export default StaticGrid
